module.exports = __webpack_public_path__ + "static/media/voulume_on.e2580b33.svg";